import PropTypes from 'prop-types';
import React from 'react';
import SubmissionFields from '.';
import { formatDateWeekdayDateTimeWithZone } from '../../../../utils/formatDate';
import Button from '../../../shared/components/Button';
import { REDIRECT } from '../../shared/reducer';
import { useStateValue } from '../../shared/state';
import shared from '../../shared/styles';
import styles from './styles';
import BravelyData from 'utils/data';

const proId = BravelyData('proId');

const DEFAULT_QUESTIONS = {
  themesPrimaryTopic: true,
  themesCustomPrimaryTopic: true,
  themesAdditionalTopics: true,
  themesNotes: true,
  proSessionNotes: true,
  themesPrimaryTheme: true,
  needsCareerMgmt: true,
  needsSkillsSuccess: true,
  needsCareerFulfillment: true,
  needsPerfEval: true,
  needsStressRelief: true,
  needsWorkRelationship: true,
  needsFairTrmnt: true,
  needsMomntInterv: true,
  needsOther: true,
  needsProgress: true,
  proAdvancePrimarySkills: true,
  proAdvanceManagingSelf: true,
  proAdvanceLeadingTeams: true,
  proAdvanceManagingRelationships: true,
};

const QUESTIONS_FOR_SESSION_PRO = {
  postSessionActionPlan: true,
  postSessionActionPlanTimeline: true,
  postSessionActionPlanDetails: true,
  impactSkillDevelopment: true,
  impactSkillDevelopmentCustom: true,
  impactFlightRiskBeforeSession: true,
  impactFlightRiskAfterSession: true,
  preSessionProductivity: true,
  preSessionEngagement: true,
  preSessionHrDisposition: true,
  preSessionHrDispositionContext: true,
  preSessionManagerDisposition: true,
  preSessionManagerDispositionContext: true,
  organizationRecommendations: true,
};

const prepareProSessionSummaryQuestions = (questions, sessionProId) => {
  const issessionPro = sessionProId === proId;
  const questionsToShow = issessionPro
    ? { ...DEFAULT_QUESTIONS, ...QUESTIONS_FOR_SESSION_PRO }
    : DEFAULT_QUESTIONS;
  return Object.keys(questions).reduce((filteredQuestions, name) => {
    if (questionsToShow[name]) filteredQuestions[name] = questions[name];
    return filteredQuestions;
  }, {});
};

const CheckInInfo = ({ context, features }) => {
  const { consult, checkIn } = context;
  const [{}, dispatch] = useStateValue();
  return (
    (checkIn.id && (
      <div className={styles.checkInContainer}>
        <h3 className={shared.category}>Check-In</h3>
        <q className={styles.checkInContent}>{checkIn.content}</q>
        {consult.sentCheckIn && (
          <div>
            Sent on <b>{formatDateWeekdayDateTimeWithZone(checkIn.sentAt)}</b>
            <Button
              className={styles.checkInButton}
              onClick={() =>
                dispatch({
                  type: REDIRECT,
                  redirectTo: checkIn.followUpUrl,
                })
              }
            >
              {consult.completedCheckIn
                ? 'View your check-in'
                : 'Complete your check-in'}
            </Button>
          </div>
        )}
        {!consult.sentCheckIn && consult.scheduledCheckIn && (
          <div>
            Scheduled for{' '}
            {formatDateWeekdayDateTimeWithZone(checkIn.scheduledAt)}
          </div>
        )}
      </div>
    )) ||
    ''
  );
};

export default function SubmissionProSessionSummary({ questions, ...props }) {
  const { id: sessionProId } = props?.context?.pro;
  return (
    <>
      <SubmissionFields
        {...props}
        questions={prepareProSessionSummaryQuestions(questions, sessionProId)}
      />
      {props.context.features.checkIns && <CheckInInfo {...props} />}
    </>
  );
}

SubmissionProSessionSummary.propTypes = {
  id: PropTypes.number.isRequired,
  questions: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
};
